/* globals coupon */

export default {
    methods: {
        async getCouponInfo(mockNum) {
            await this.$store.dispatch('getCouponInfo', mockNum);
        }
    }
};
